const Style = {
  content: 'relative max-w-screen-lg mx-5 sm:mx-7 lg:mx-auto h-full',
}

export default Style
